"use client";

import React from "react";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IhrStressfreierUmzugInHamburg() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: trustRef,
    isVisible: isTrustVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="222469" id="national-command-center" className="relative min-h-[90vh] md:min-h-screen flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636043/img/topographic-map-pattern.png')] bg-cover bg-center bg-no-repeat opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/95 via-white/80 to-white/95" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center pt-20 pb-32">
        
        {}
        <h1 ref={headlineRef} className={`flex flex-col gap-2 md:gap-4 transition-all duration-1000 ease-out transform ${isHeadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <span className="block text-secondary text-5xl sm:text-6xl md:text-7xl lg:text-[7rem] font-default font-bold uppercase tracking-tighter leading-[0.9]">
            National Portable Sanitation
          </span>
          <span className="block text-primary text-5xl sm:text-6xl md:text-7xl lg:text-[7rem] font-default font-bold uppercase tracking-tighter leading-[0.9]">
            Solutions. Fast, Reliable.
          </span>
        </h1>

        {}
        <div ref={trustRef} className={`mt-8 md:mt-12 flex items-center gap-3 bg-white/50 backdrop-blur-md border border-secondary/10 rounded-full px-5 py-2.5 shadow-sm transition-all duration-1000 delay-300 ease-out transform ${isTrustVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-1">
            {[...Array(5)].map((_, i) => <Star key={i} data-index={i} className="w-4 h-4 md:w-5 md:h-5 fill-primary text-primary" />)}
          </div>
          <span className="text-secondary text-sm md:text-base font-medium tracking-wide">
            Enterprise Grade Service Network
          </span>
        </div>

        {}
        <div ref={ctaRef} className={`mt-10 md:mt-14 w-full md:w-auto transition-all duration-1000 delay-500 ease-out transform ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Link to="#quote" className="block w-full md:w-auto">
            <Button size="lg" className="w-full md:w-[300px] h-16 text-lg md:text-xl font-bold uppercase tracking-wide rounded-xl shadow-xl hover:scale-105 transition-transform duration-300 bg-primary text-primary-foreground">
              Get a Quote
            </Button>
          </Link>
        </div>

      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 z-10">
        <span className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-secondary/60 font-medium">
          Explore Solutions
        </span>
        <div className="w-[2px] h-12 md:h-16 bg-secondary/10 relative overflow-hidden rounded-full">
          <div className="absolute top-0 left-0 w-full h-1/3 bg-primary animate-[bounce_2s_infinite]" />
        </div>
      </div>
    </section>;
}